<template>
  <div class="menuscrpt_contianer">
    <div class="owner_title">上传附件</div>
    <div class="upload_manuscript_box" v-show="equipmentType == 0 ? true : false">
      <el-upload class="upload-demo  manuscript_upload" :action="uploadUrl" :on-preview="handlePreview"
        :on-remove="handleRemove" :before-remove="beforeRemove" multiple :on-exceed="handleExceed"
        :on-success="uploadSuccess" :disabled="uploadState">
        <el-button class="el-upload__text">
          <i class="iconfont icon-shangchuan"></i>上传稿件
        </el-button>
      </el-upload>
      <div slot="tip" class="el-upload__tip" v-show="upload_tip">
        只能上传zip/doc/docx文件
      </div>
    </div>
    <!-- 手机端 -->
    <div class="mobile_upload" @click="handleUploadMobile" v-show="equipmentType == 1 ? true : false">
      <el-button type="primary">
        <i class="iconfont icon-shangchuan"></i>上传稿件
      </el-button>
    </div>
    <div class="menuscript_table">
      <div class="menuscript_table_title">查重结果</div>
      <el-table class="table_box" :data="dataShow" height="500" v-horizontal-scroll="'always'" border style="width: 98%"
        v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="departmentuser_name" label="金主昵称" align="center" sortable width="180">
        </el-table-column>
        <el-table-column property="writer_nickname" label="写手昵称" align="center" sortable width="160">
        </el-table-column>
        <el-table-column property="connectionessay_name" label="书名" align="center" sortable width="300">
        </el-table-column>
        <el-table-column property="writer_cost" label="写手千字价格" align="center" sortable width="180">
        </el-table-column>
        <el-table-column property="word_number" label="字数" align="center" sortable width="130">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.word_number == '不达标'" type="danger">
              {{ scope.row.word_number }}
            </el-tag>
            <div v-else class="font_color">
              {{ scope.row.word_number }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="start_chapters" label="开始章节" align="center" sortable width="130">
          <template slot-scope="scope">
            <div :class="scope.row.color == 1 ? 'font_color' : 'chapters_color'">
              {{ scope.row.start_chapters }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="end_chapters" label="结束章节" align="center" sortable width="130">
          <template slot-scope="scope">
            <div :class="scope.row.color == 1 ? 'font_color' : 'chapters_color'">
              {{ scope.row.end_chapters }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="originDegree" label="查重率" align="center" width="130" sortable>
          <!-- /查重校验:0=处理中,1=通过,-1=驳回 -->
          <template slot-scope="scope">
            <div :class="scope.row.originDegree_color == 1 ? 'chapters_color' : ''">
              {{ scope.row.originDegree }}%
            </div>
          </template>
        </el-table-column>
        <el-table-column property="record_time" label="上传时间" align="center" sortable width="250">
        </el-table-column>
        <el-table-column :fixed="equipmentType == 1 ? false : 'right'" label="操作" align="center" width="320">
          <template slot-scope="scope">
            <div class="menuscript_btn_box">
              <div @click="checkResult(scope.row)" class="menuscript_btn">
                <i class="iconfont icon-zongcejieguochakan"></i>
                查重结果
              </div>
              <div @click="menuscriptDialog(scope.row)" :disabled="scope.row.status == -1 || scope.row.is_num == 0"
                class="menuscript_btn">
                <i class="iconfont icon-apply"></i>压稿
              </div>
              <div @click="priceDialog(scope.row)" :disabled="scope.row.status == -1 || scope.row.is_num == 0"
                class="menuscript_btn">
                <i class="iconfont icon-jinqian-yuan"></i>差价
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination class="pagination_box" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
      <!-- 压稿弹窗 -->
      <el-dialog class="dialog_input" title="压稿金额" :visible.sync="menuscriptDialogVisible" width="30%" center>
        <el-form :model="menuscriptForm" class="menuscript_form_dialog" :rules="costFormRules">
          <el-form-item label="输入压稿金额:" prop="deposit_money">
            <el-input v-model="menuscriptForm.deposit_money"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="dialog_btn" round type="primary" @click="submitMenuscript">确认</el-button>
          <el-button class="dialog_btn" round @click="menuscriptDialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 差价弹窗 -->
      <el-dialog title="差价" :visible.sync="priceDialogVisible" width="30%" center>
        <el-form :model="priceForm" class="menuscript_form_dialog">
          <el-form-item label="输入差价金额:">
            <el-input v-model="priceForm.manuscript_diff"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="dialog_btn" round type="primary" @click="submitPriceDialog">确认</el-button>
          <el-button class="dialog_btn" round @click="priceDialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  connectionrecord_list,
  deposit_operate,
  manuscript_operate,
  connectionrecord_zip,
  file_operate,
  word_operate
} from "@/utils/writer";

export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl,
      // uploadUrl: "https://npdhwh.fzbykj.com/addons/alioss/index/upload",
      writerId: "", //用户id
      manuscriptList: [], //查重列表
      menuscriptDialogVisible: false, //压稿弹窗
      menuscriptForm: {
        deposit_money: "" //压稿费用
      },
      costFormRules: {
        deposit_money: { pattern: /^[0-9|^\\.]/, message: "数值不能为负数" }
      },
      priceForm: {
        manuscript_diff: "" //差价
      },
      priceDialogVisible: false, //差价弹窗
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      file_list: [], //上传文件路径
      fileUrl: "", //文件上传路径
      uploadState: false, //文件上传前，判断手机还PC   false:可上传  true:不可上传
      upload_tip: true, //上传稿件的提示
      loading: true, //数据加载
      equipmentType: 0 //设备 0-pc端 1移动端
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    this.getMenuScript();
    // this.uploadFileCheck();
  },
  // mounted() {
  //   if (this.timer) {
  //     clearInterval(this.timer);
  //   } else {
  //     this.timer = setInterval(() => {
  //       this.getMenuScript(); //再次加载数据,自己定义的方法
  //     }, 10000); //每隔十秒刷新一次
  //   }
  // },
  methods: {
    // 获取查重列表
    getMenuScript() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 100
      };
      connectionrecord_list(obj).then(res => {
        if (res.data.code == 1) {
          that.loading = false;
          // that.total = res.data.data.length;
          that.total = res.data.data.data_count;
          that.manuscriptList = res.data.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handleUploadMobile() {
      this.$router.push({ path: "uploadFile" });
    },
    // 判断是手机端还是PC端
    // uploadFileCheck() {
    //   var that = this;
    //   let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    //     navigator.userAgent
    //   );
    //   if (flag) {
    //     that.uploadState = true;
    //     this.$router.push({ path: "uploadFile" });
    //   }
    // },
    // 上传稿件
    uploadSuccess(val) {
      var that = this;

      var file_url = val.data.url;
      var suffix = file_url.substring(file_url.lastIndexOf(".") + 1);
      if (suffix == "zip") {
        // 上传压缩包
        let zip_obj = {
          departmentuser_id: that.writerId,
          file: file_url
        };
        connectionrecord_zip(zip_obj).then(res => {
          that.upload_tip = false;
          if (res.data.code == 1) {
            var fail_data = res.data.data.fail;
            var success_data = res.data.data.success;
            var success_msg = success_data.join(",");

            if (fail_data.length > 0) {
              fail_data.forEach(element => {
                that.$message({
                  showClose: true,
                  duration: 0,
                  type: "error",
                  message: element + ",该写手不存在对应书籍，上传失败!"
                });
              });
            }
            if (success_msg) {
              that.$message({
                offset: 60,
                type: "success",
                message: success_msg + ",上传成功！"
              });
            }
            that.getMenuScript();
          } else {
            var fail_arr = [];
            fail_arr = res.data.msg;
            fail_arr.forEach(item => {
              that.$message({
                showClose: true,
                offset: 60,
                duration: 0,
                type: "error",
                message: item
              });
            });
          }
        });
      } else if (suffix == "docx" || suffix == "doc") {
        // 上传word文档
        let docx_obj = {
          departmentuser_id: that.writerId,
          file: file_url
        };
        word_operate(docx_obj).then(res => {
          that.upload_tip = false;
          if (res.data.code == 1) {
            that.$message.success(res.data.msg);
            that.getMenuScript();
          } else {
            that.$message({
              showClose: true,
              duration: 0,
              type: "error",
              message: res.data.msg
            });
          }
        });
      } else {
        this.$message.error("文件格式不符合要求");
      }
    },
    // 查重结果
    checkResult(val) {
      var that = this;
      var url = val.reportUrl;
      if (url === "") {
        that.$message.error("查重结果未生成，请稍后！");
      } else {
        window.open(url, "_blank");
      }
    },
    // 压稿
    menuscriptDialog(val) {
      var that = this;
      that.menuscriptDialogVisible = true;
      that.menuscriptForm = { ...val };
    },
    // 确认压稿
    submitMenuscript() {
      var that = this;
      if (that.menuscriptForm.deposit_money < 0) {
        this.$message.error("数值不能未负数");
        return false;
      }
      let obj = {
        departmentuser_id: that.writerId, //所属写手部id
        connectionrecord_id: that.menuscriptForm.id, //所属查重结果列表id
        deposit_money: that.menuscriptForm.deposit_money
      };
      deposit_operate(obj).then(res => {
        if ((res.data.code = 1)) {
          that.getMenuScript();
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
        that.menuscriptDialogVisible = false;
      });
    },
    // 差价
    priceDialog(val) {
      var that = this;
      that.priceDialogVisible = true;
      that.priceForm = { ...val };
    },
    // 确认差价
    submitPriceDialog() {
      var that = this;

      let obj = {
        departmentuser_id: that.writerId, //所属写手部id
        connectionrecord_id: that.priceForm.id, //所属查重结果列表id
        manuscript_diff: that.priceForm.manuscript_diff
      };
      manuscript_operate(obj).then(res => {
        if ((res.data.code = 1)) {
          that.getMenuScript();
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
        that.priceDialogVisible = false;
      });
    },
    // 计算页数的方法
    calcPageData() {
      if (this.manuscriptList.length > 1) {
        this.pageNum = Math.ceil(this.manuscriptList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.manuscriptList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      var that = this;
      that.loading = true;
      this.currentPage = val;
      let obj = {
        departmentuser_id: that.writerId,
        page: val,
        page_index: this.pageSize
      };
      connectionrecord_list(obj).then(res => {
        if (res.data.code == 1) {
          that.loading = false;
          that.total = res.data.data.data_count;
          that.dataShow = res.data.data.data;
        }
      });
      this.dataShow = this.totalPageData[val - 1];
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  },
  destroyed() {
    //页面关闭时调用
    clearInterval(this.timer);
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
}

.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.upload_manuscript_box {
  text-align: center;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload_tip {
  display: none;
}

.manuscript_upload {
  background: #f3f8ff;
  border: 2px dotted #157df8;
  width: 515px;
  height: 160px;
  line-height: 158px;
}

.manuscript_upload .el-button {
  font-size: 20px;
  border: none;
  background: #f3f8ff;
  color: #157df8;
  font-weight: 500;
}

.menuscrpt_contianer {
  /* height: 100%; */
  /* background: #ffffff; */
}

.menuscript_table {
  padding: 20px;
}

.menuscript_table_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  margin: 10px 15px;
}

.menuscript_btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.menuscript_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
}

.menuscript_btn i {
  font-size: 12px;
}

.menuscript_table .el-button:focus,
.el-button:hover {
  color: #fff;
  border-color: #c6e2ff;
  background-color: #157df8;
}

.menuscript_form_dialog {
  width: 400px;
}

.menuscript_form_dialog .el-form-item {
  display: flex;
  flex-direction: row;
}

.menuscript_form_dialog .el-input {
  width: 270px;
  border: 1px solid #dcdfe6 !important;
}

.font_color {
  color: #42d46e;
}

.chapters_color {
  color: #f11c1c;
}

.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}

.mobile_upload {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: #f3f8ff;
  border: 2px dotted #157df8;
  width: 515px;
  height: 160px;
  line-height: 158px;
}

@media screen and (max-width: 750px) and (min-width: 375px) {
  .menuscript_table {
    margin-bottom: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/writer/UploadManuscript.vue